/**
 * Default Color Scheme for the feedback component
 *
 * [Light Mode]
 * @export
 */
export var DefaultLightColor = {
    palette: {
        themePrimary: '#323130',
        themeLighterAlt: '#e7e6e5',
        themeLighter: '#d0cfce',
        themeLight: '#bab8b7',
        themeTertiary: '#a3a2a0',
        themeSecondary: '#8d8b8a',
        themeDarkAlt: '#767573',
        themeDark: '#605e5d',
        themeDarker: '#494847',
        neutralLighterAlt: '#f8f8f8',
        neutralLighter: '#f4f4f4',
        neutralLight: '#eaeaea',
        neutralQuaternaryAlt: '#dadada',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c8c8',
        neutralTertiary: '#111111',
        neutralSecondary: '#171616',
        neutralSecondaryAlt: '#171616',
        neutralPrimaryAlt: '#1d1c1b',
        neutralPrimary: '#323130',
        neutralDark: '#282726',
        black: '#2d2c2c',
        white: '#ffffff',
    },
};
/**
 * Default Color Scheme for the feedback component
 *
 * [Dark Mode]
 * @export
 */
export var DefaultDarkColor = {
    palette: {
        themePrimary: '#ffffff',
        themeLighterAlt: '#767676',
        themeLighter: '#a6a6a6',
        themeLight: '#c8c8c8',
        themeTertiary: '#d0d0d0',
        themeSecondary: '#dadada',
        themeDarkAlt: '#eaeaea',
        themeDark: '#f4f4f4',
        themeDarker: '#f8f8f8',
        neutralLighterAlt: '#323130',
        neutralLighter: '#31302f',
        neutralLight: '#2f2e2d',
        neutralQuaternaryAlt: '#2c2b2a',
        neutralQuaternary: '#2a2928',
        neutralTertiaryAlt: '#282726',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralSecondaryAlt: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#f8f8f8',
        white: '#323130',
    },
};
//# sourceMappingURL=DefaultFeedbackTheme.js.map